// import Vue from '../../libs/vue/vue.common'
import {getDistanceSimple} from '../../libs/geolib/geolib'
import api from './api'
import VPager from './VPager'

export default function instSearch () {

	const myapp = new Vue({
		delimiters: ['${', '}'],
		el: '#v-inst-search',
		components: {VPager},
		data () {

			// urlからパラメーターを取得
			const params = {}
			location.search.replace(/^\?/, '').split('&').forEach(str => {
				const keyval = str.split('=')
				params[keyval[0]] = decodeURIComponent(keyval[1])
			})

			return {
				// マスターデータ
				servicedevs: null,
				distincts: null,
				services: null,

				// 1ページあたりのアイテム数
				perpage: 20,

				// 状態
				service_dev: params.service_dev || '',
				district: params.district || '',
                day: params.day || '',
                time_hour: params.time_hour || '',
                time_minute: params.time_minute || '',
                keyword: params.keyword || '',
				service: params.service || '',
				sortDistance: params.sortDistance || '',
				page: (params.page - 0) || 1,

				// 病院データ
				loadingInstitutions: false,
				institutions: null,

				// 現在地 {lat, lng}
				loadingCurrentPosition: false,
				currentPosition: null
			}
		},
        filters: {
            time_format: function (value) {
                if (!value) return '';
                return value.slice( 0, 5 );
            }
        },
		computed: {
			// マスターデータ読み込み中
			loadingMasterData () {
				return !this.servicedevs && !this.distincts && !this.services
			},

			// service_devが選択されてるときのその子の診療科目一覧
			childServices () {
				// return null
				if (!this.service_dev || !this.services) {
					return null
				}
				return this.services.filter(service => service.service_dev_id == this.service_dev)
			},

			// 検索条件によって表示する全ての病院データ
			// 診療科目以外はサーバーサイドで生成、診療科目のみこちらでフィルタリング
			filteredInstitutions () {
				if (!this.institutions) {
					return null
				}
				if (!this.service) {
					return this.institutions
				}
				return this.institutions.filter(inst => (inst.services || '').split(',').findIndex(id => id == this.service) >= 0)
			},

			// ページで表示する病院データの配列
			pageInstitutions () {
				if (!this.filteredInstitutions) {
					return null
				}

				const institutions = [].concat(this.filteredInstitutions)

				// 必要なら現在地から近い順にソート
				// if (this.currentPosition && this.sortDistance) {
				if (this.currentPosition) {
					institutions.sort((a, b) => {
						const aDistance = (a.lat && a.lng) ? this.getDistance(a.lat, a.lng) : Infinity
						const bDistance = (b.lat && b.lng) ? this.getDistance(b.lat, b.lng) : Infinity
						if (aDistance < bDistance) {
							return -1
						}
						if (aDistance > bDistance) {
							return 1
						}
						return 0
					})
				}

				const start = this.perpage * (this.page - 1)
				return institutions.splice(start, this.perpage)
			},

			total () {
				return this.filteredInstitutions ? this.filteredInstitutions.length : 0
			},
			start () {
				return this.perpage * (this.page - 1) + 1
			},
			end () {
				return Math.min(this.perpage * this.page, this.total)
			},

			maxPage () {
				return Math.ceil(this.total / this.perpage)
			}

		},
		methods: {

			// 状態 -> URL
			state2url () {
				let paramsStr = ['service_dev','district','day','time_hour','time_minute','keyword','service','sortDistance']
					.filter(key => this[key])
					.map(key => key + '=' + encodeURIComponent(this[key]))
				if (this.page >= 2) {
					paramsStr.push(`page=${this.page}`)
				}
				paramsStr = paramsStr.join('&')

				const url = location.pathname + (paramsStr ? '?' + paramsStr : '')

				history.replaceState(null, null, url)
			},

			loadMasterData () {
				api.institutions.servicedevs().then(data => {
					// 連想配列を配列に（idの昇順）
					this.servicedevs = Object.values(data).sort((a,b) => a.id - b.id)
				})
				api.institutions.distincts().then(data => {
					// 連想配列を配列に（idの昇順）
					this.distincts = Object.values(data).sort((a,b) => a.id - b.id)
				})
				api.institutions.services().then(data => {
					// 連想配列を配列に（sortの昇順）
					this.services = Object.values(data).sort((a,b) => a.sort - b.sort)
				})
			},

			loadInstitutions () {
				const params = {
					service_dev: this.service_dev,
					district_id: this.district,
                    day: this.day,
                    time_hour: this.time_hour,
                    time_minute: this.time_minute,
					keyword: this.keyword
				};
				this.loadingInstitutions = true
				this.institutions = null
				api.institutions(params).then(data => {
					this.institutions = data
					this.loadingInstitutions = false
				}).catch(err => {
					this.loadingInstitutions = false
				})
			},

			changeState () {
				this.service = ''
				this.page = 1
				this.state2url()
				this.loadInstitutions()
			},

			getServiceCount (id) {
				if (!this.institutions) {
					return 0
				}
				return this.institutions.filter(inst => {
					return (',' + inst.services + ',').indexOf(',' + id + ',') >= 0
				}).length
			},

			isSelectedService (id) {
				return id == this.service
			},

			selectService (id) {
				if (id == this.service) {
					return
				}
				this.service = id || ''
				this.page = 1
				this.state2url()
			},

			changePage (page) {
				this.page = page
				this.state2url()
				this.scrollToList()
			},

			scrollToList () {
				const header = document.querySelector('.header')
				const headerH = header ? header.getBoundingClientRect().height : 0
				const x = window.pageXOffset
				const y = window.pageYOffset + this.$refs.listHeader.getBoundingClientRect().top - headerH
				window.scrollTo(x, y)
			},

			loadCurrentPosition () {
				this.loadingCurrentPosition = true
				navigator.geolocation.getCurrentPosition(pos => {
					const lat = pos.coords.latitude
					const lng = pos.coords.longitude
					this.currentPosition = {lat, lng}
					this.loadingCurrentPosition = false
					sessionStorage.setItem('currentPosition', JSON.stringify({lat, lng}))
				}, () => {
					this.currentPosition = null
					this.loadingCurrentPosition = false
					alert('現在地を取得できませんでした')
				})
			},

			setCurrentPositionFromCache () {
				const cache = sessionStorage.getItem('currentPosition')
				if (cache) {
					this.currentPosition = JSON.parse(cache)
				}
			},

			getDistance (lat, lng) {
				if (!lat || !lng || !this.currentPosition) {
					return null
				}
				return getDistanceSimple({
					latitude: this.currentPosition.lat,
					longitude: this.currentPosition.lng
				}, {
					latitude: lat,
					longitude: lng
				})
			},

			instRouteLink (inst) {
				if (!inst.lat || !inst.lng || !this.currentPosition) {
					return ''
				}
				const saddr = this.currentPosition.lat + ',' + this.currentPosition.lng // 出発地
				const daddr = inst.lat + ',' + inst.lng // 到着地
				const dirflg = 'd' // 交通手段 r:電車, w:徒歩,d:自動車
				return `https://www.google.co.jp/maps?saddr=${saddr}&daddr=${daddr}&dirflg=${dirflg}`
			},
			instDistance (inst) {
				const distance = this.getDistance(inst.lat, inst.lng)
				if (distance === null) {
					return ''
				}
				return distance < 1000 ? Math.round(distance) + 'm' : Math.round(distance / 100) / 10 + 'km'
			}
		},
		created: function () {
			// this.url2state()
			this.loadMasterData()
			this.setCurrentPositionFromCache()
			this.loadInstitutions()
		}
	})

}